"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const elements_ui_components_title_1 = __importStar(require("@hydrogen/elements.ui.components.title"));
const elements_ui_configs_1 = require("@hydrogen/elements.ui.configs");
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const themes_1 = require("../themes");
const ContentBoxTitle = (props) => {
    const layout = props.layout || 'card';
    const theme = themes_1.themes.contentBoxTitle.layouts[layout];
    const Link = (0, elements_ui_configs_1.getLink)();
    return (react_1.default.createElement(elements_ui_components_title_1.default, { type: (props.isMainBox ? elements_ui_components_title_1.TitleTypes.cardMain : elements_ui_components_title_1.TitleTypes.card), as: (props.isMainBox ? 'h1' : 'h2') }, props.href
        ? (react_1.default.createElement(Link, { to: props.href, state: props.state },
            props.title,
            react_1.default.createElement(elements_ui_icon_1.default, { icon: theme.states.linked.icon.icon, className: (0, elements_ui_utils_1.classNames)(theme.states.linked.icon.layer, props.arrowIconClassName ? '-mt-1 rtl:rotate-180' : 'ms-2 -mt-1 rtl:rotate-180', props.arrowIconClassName ? props.arrowIconClassName : ''), size: elements_ui_icon_1.IconsSizes.small }),
            react_1.default.createElement("span", { className: "inset-0 absolute" })))
        : props.title || null));
};
exports.default = ContentBoxTitle;
//# sourceMappingURL=ContentBoxTitle.js.map